import { render, staticRenderFns } from "./OrderItemsBreakdownTable.vue?vue&type=template&id=92531374&scoped=true&"
import script from "./OrderItemsBreakdownTable.vue?vue&type=script&lang=js&"
export * from "./OrderItemsBreakdownTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemsBreakdownTable.vue?vue&type=style&index=0&id=92531374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92531374",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92531374')) {
      api.createRecord('92531374', component.options)
    } else {
      api.reload('92531374', component.options)
    }
    module.hot.accept("./OrderItemsBreakdownTable.vue?vue&type=template&id=92531374&scoped=true&", function () {
      api.rerender('92531374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shopApp/routes/shop/merchant/queue/OrderItemsBreakdownTable.vue"
export default component.exports